import { render } from "./Loadbar.vue?vue&type=template&id=87a9912c"
import script from "./Loadbar.vue?vue&type=script&lang=js"
export * from "./Loadbar.vue?vue&type=script&lang=js"

import "./Loadbar.vue?vue&type=style&index=0&id=87a9912c&lang=scss"
script.render = render

export default script